export enum OrgSimulationState {
  Created = 'Created',
  Published = 'Published'
}
